import React from 'react';
import { useCompanyContext } from '../../../contexts/Company';
import { useLinesContext } from '../../../contexts/Lines';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Stepper from '../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import PageLayout from '../../../components/Onboarding/Company/StoreUrl';
import Note from '../../../components/Onboarding/BuildingBlocks/Note';
import NoStore from '../../../components/Onboarding/Company/NoStore';
import { STORE_URL_SUBTITLE } from '../../../components/Onboarding/messages';

const useStyles = makeStyles((theme: any) => ({
  note: { maxWidth: 700 },
}));

export default function StoreUrl() {
  const classes = useStyles();
  const { business } = useCompanyContext();
  const { products } = useLinesContext();

  return (
    <>
      <Stepper
        title="What's your store URL?"
        subtitle={STORE_URL_SUBTITLE}
        hideContent={!(products && business)}
        headerWidth={800}
        contentWidth={800}
      >
        <PageLayout />
      </Stepper>
      {products && business && (
        <Container className={classes.note}>
          <Note header="No Store URL?">
            <NoStore />
          </Note>
        </Container>
      )}
    </>
  );
}
